export default {

  solidFuelBoilersCount(self) {
    let solidFuelBoilersCount = 0;
    self.$parent.$refs[`screen2`].heatSources.forEach((el) => {
      if (el.type.is_solid_fuel) {
        solidFuelBoilersCount += parseInt(el.amount);
      }
    });
    return solidFuelBoilersCount;
  },

  showMessage(self, text) {
    self.$notify({
      reverse: true,
      duration: 4000,
      group: 'declaration',
      type: 'error',
      title: 'Błąd w podanych danych',
      text: text
    });
  }
}
